import parseToken from "../../../helpers/parseToken"
import {createContext, useEffect, useState} from "react"
import {message} from "antd"
import {getTenantsDealer} from "../../../services/api/apiSetting"
import queryString from 'query-string'
import {getTenantParam} from "../../../services/api/apiCommon"
import {getAllRole} from "../../../services/api/apiUser"

export const Context = createContext({})

export const Provider = (props) => {
    const info = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({
        name: '',
        status: ''
    })

    const [pagination, setPagination] = useState({
        page: 1,
        size: 50
    })
    const [listTenantDealer, setListTenantDealer] = useState()
    const [total, setTotal] = useState(0)
    const [listRoles, setListRoles] = useState([])
    const [listNumbers, setListNumbers] = useState([])
    const [listTypeCampaigns, setListTypeCampaigns] = useState([])
    const [listCallRates, setListCallRates] = useState([])


    const _onChangeFilter = (name, value) => {
        setFilters({
            ...filters,
            [name]: value
        })
    }

    const _fetchListSettingTenantDealer = async () => {
        setLoading(true)
        setError('')

        try {
            const query = {
                ...filters,
                ...pagination
            }

            const newQueryString = queryString.stringify(query)

            const response = await getTenantsDealer(newQueryString, info.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setLoading(false)
            setError('')
            setListTenantDealer(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListRole = async () => {
        try {
            const response = await getAllRole({}, info.sub)

            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            setListRoles(data)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _fetchListTenantParam = async () => {
        try {
            const payload = {
                parName: ["CALL_NUMBER", "CP_TYPE", "AUTOCAL_CCU"]
            }
            const response = await getTenantParam(info.sub, payload)
            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error("Không thể lấy danh sách type lỗi: " + error_message)
            }

            setListNumbers(data.filter(item => item.parName === 'CALL_NUMBER'))
            setListTypeCampaigns(data.filter(item => item.parName === 'CP_TYPE'))
            setListCallRates(data.filter(item => item.parName === 'AUTOCAL_CCU'))
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListRole()
        _fetchListTenantParam()
        _fetchListSettingTenantDealer()

        return () => {
            setLoading(false)
            setError('')
        }
        // eslint-disable-next-line
    }, [filters, pagination])

    return (
        <Context.Provider
            value={{
                loading,
                error,
                filters,
                pagination,
                total,
                listTenantDealer,
                listRoles,
                listNumbers,
                listTypeCampaigns,
                listCallRates,
                setPagination,
                onChangeFilter: _onChangeFilter,
                getListSettingTenantDealer: _fetchListSettingTenantDealer,
                getListRole: _fetchListRole
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as SettingTenantDealerContext,
    Provider as SettingTenantDealerProvider
} from './SettingTenantDealerContext'
